import PodcastManager from './PodcastManager'

const PodcastType = (url) => {
  // if (url.indexOf('https://soundcloud.com') > -1) return 'soundcloud'
  // else if (url.indexOf('https://open.spotify.com') > -1) return 'spotify'
  // else if (url.indexOf('https://anchor.fm') > -1) return 'anchor'
  if (url && url.indexOf('https://anchor.fm') > -1) return 'anchor'
  else return null
}

export default new PodcastManager('anchor')
